import { render } from "./Privacidad.vue?vue&type=template&id=7fea5f37"
import script from "./Privacidad.vue?vue&type=script&lang=js"
export * from "./Privacidad.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__